(function ($) {
  $(function () {
    var $siteHeader = $('.site-header.is-sticky');

    if ($siteHeader.length) {
      $(window).on('scroll', function () {
        $siteHeader.toggleClass('navbar-fixed-top', $(this).scrollTop() > 1);
      });
    }

    $(window).on('scroll', function () {
      $('.scroll-to-top').toggleClass('show', $(this).scrollTop() > 150);
    }); 

    $('.scroll-to-top, .footer-scroll-top').on('click', function (event) {
      event.preventDefault(); 

      $('html, body').animate({
        scrollTop: 0
      }, 700);
    });

  });
})(jQuery);

(function (window, document) {
  'use strict';

  var navigation = document.querySelector('#mobile-navigation');
  var panel = navigation && navigation.querySelector('.mobile-navigation-panel');
  var openButton = document.querySelector('.js-mobile-menu-open');
  var closeButton = navigation && navigation.querySelector('.js-mobile-menu-close');

  if (!navigation || !panel || !openButton || !closeButton) {
    return;
  }

  var submenuParents = navigation.querySelectorAll('.menu-item-has-children');
  var lastFocusedElement = null;

  Array.prototype.forEach.call(submenuParents, function (menuItem, index) {
    var submenu = menuItem.querySelector(':scope > .sub-menu');

    if (!submenu) {
      return;
    }

    var toggle = document.createElement('button');
    var submenuId = 'mobile-submenu-' + index;
    var label = menuItem.querySelector(':scope > a');

    submenu.id = submenuId;
    toggle.type = 'button';
    toggle.className = 'mobile-submenu-toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', submenuId);
    toggle.setAttribute('aria-label', (label ? label.textContent.trim() + ': ' : '') + 'Untermenü');
    menuItem.insertBefore(toggle, submenu);

    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';

      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      menuItem.classList.toggle('is-submenu-open', !isOpen);
    });
  });

  function getFocusableElements() {
    return panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
  }

  function openMenu() {
    lastFocusedElement = document.activeElement;
    navigation.classList.add('is-open');
    navigation.setAttribute('aria-hidden', 'false');
    openButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mobile-navigation-open');
    window.requestAnimationFrame(function () {
      closeButton.focus();
    });
  }

  function closeMenu() {
    navigation.classList.remove('is-open');
    navigation.setAttribute('aria-hidden', 'true');
    openButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('mobile-navigation-open');

    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  openButton.addEventListener('click', openMenu);
  closeButton.addEventListener('click', closeMenu);

  navigation.addEventListener('click', function (event) {
    if (event.target.closest('a')) {
      closeMenu();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!navigation.classList.contains('is-open')) {
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      closeMenu();
      return;
    }

    if (event.key === 'Tab') {
      var focusableElements = getFocusableElements();
      var firstElement = focusableElements[0];
      var lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }
  });

})(window, document);

(function (window, document) {
  'use strict';

  var wordmarks = document.querySelectorAll('.footer-wordmark');

  Array.prototype.forEach.call(wordmarks, function (wordmark) {
    var svg = wordmark.querySelector('.js-footer-wordmark-svg');
    var baseText = wordmark.querySelector('.footer-wordmark-base-text');
    var maskText = wordmark.querySelector('.footer-wordmark-mask-text');
    var trailGroup = wordmark.querySelector('.js-footer-wordmark-trail');

    if (!svg || !baseText || !maskText || !trailGroup) {
      return;
    }

    var namespace = 'http://www.w3.org/2000/svg';
    var segmentCount = 30;
    var headRadius = 64;
    var tailRadius = 11;
    var follow = .2;
    var hoverPadding = 22;
    var boundsPadding = 26;
    var pointerEase = .22;
    var idleEase = .055;
    var idleMaxSpeed = 20;
    var idleTurnRate = .35;
    var idleDrift = 9;
    var idleOpacity = .28;
    var hoverOpacity = 1;
    var circles = [];
    var points = [];
    var target = { x: 960, y: 250 };
    var hovering = false;
    var angle = Math.random() * Math.PI * 2;
    var speed = 8;
    var textBounds = null;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function getTextBounds() {
      try {
        var box = baseText.getBBox();

        textBounds = {
          left: box.x - boundsPadding,
          right: box.x + box.width + boundsPadding,
          top: box.y - boundsPadding,
          bottom: box.y + box.height + boundsPadding
        };
      } catch (error) {
        textBounds = { left: 0, right: 1920, top: 0, bottom: 500 };
      }

      target.x = clamp(target.x, textBounds.left, textBounds.right);
      target.y = clamp(target.y, textBounds.top, textBounds.bottom);
    }

    function toSvgPoint(clientX, clientY) {
      var point = svg.createSVGPoint();
      var matrix = svg.getScreenCTM();

      point.x = clientX;
      point.y = clientY;

      return matrix ? point.matrixTransform(matrix.inverse()) : point;
    }

    function isOverText(point) {
      return textBounds &&
        point.x >= textBounds.left - hoverPadding &&
        point.x <= textBounds.right + hoverPadding &&
        point.y >= textBounds.top - hoverPadding &&
        point.y <= textBounds.bottom + hoverPadding;
    }

    function createTrail() {
      var index;

      for (index = 0; index < segmentCount; index += 1) {
        var circle = document.createElementNS(namespace, 'circle');
        var progress = index / (segmentCount - 1);
        var radius = headRadius + (tailRadius - headRadius) * progress;

        circle.setAttribute('r', radius);
        trailGroup.appendChild(circle);
        circles.push(circle);
        points.push({ x: target.x, y: target.y });
      }
    }

    function setTrailOpacity(value) {
      trailGroup.setAttribute('opacity', value);
    }

    function moveIdleTarget() {
      angle += (Math.random() - .5) * idleTurnRate;
      speed = clamp(speed + (Math.random() - .5) * idleDrift, 4, idleMaxSpeed);
      target.x += Math.cos(angle) * speed;
      target.y += Math.sin(angle) * speed;

      if (target.x <= textBounds.left || target.x >= textBounds.right) {
        angle = Math.PI - angle;
        target.x = clamp(target.x, textBounds.left, textBounds.right);
      }

      if (target.y <= textBounds.top || target.y >= textBounds.bottom) {
        angle = -angle;
        target.y = clamp(target.y, textBounds.top, textBounds.bottom);
      }
    }

    function render() {
      var index;
      var easing = hovering ? pointerEase : idleEase;

      if (!hovering && !reducedMotion) {
        moveIdleTarget();
      }

      points[0].x += (target.x - points[0].x) * easing;
      points[0].y += (target.y - points[0].y) * easing;

      for (index = 1; index < points.length; index += 1) {
        points[index].x += (points[index - 1].x - points[index].x) * follow;
        points[index].y += (points[index - 1].y - points[index].y) * follow;
      }

      for (index = 0; index < circles.length; index += 1) {
        circles[index].setAttribute('cx', points[index].x);
        circles[index].setAttribute('cy', points[index].y);
      }

      setTrailOpacity(hovering ? hoverOpacity : idleOpacity);
      window.requestAnimationFrame(render);
    }

    wordmark.addEventListener('pointermove', function (event) {
      var point = toSvgPoint(event.clientX, event.clientY);

      hovering = isOverText(point);

      if (hovering) {
        target.x = clamp(point.x, textBounds.left, textBounds.right);
        target.y = clamp(point.y, textBounds.top, textBounds.bottom);
      }
    }, { passive: true });

    wordmark.addEventListener('pointerleave', function () {
      hovering = false;
    }, { passive: true });

    getTextBounds();
    target.x = (textBounds.left + textBounds.right) / 2;
    target.y = (textBounds.top + textBounds.bottom) / 2;
    createTrail();
    render();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(getTextBounds);
    }

    if (typeof window.ResizeObserver !== 'undefined') {
      new window.ResizeObserver(getTextBounds).observe(svg);
    } else {
      window.addEventListener('resize', getTextBounds);
    }
  });
})(window, document);
